import { configureStore } from '@reduxjs/toolkit'

import chatterReports from './chatter-reports'
import conversation from './conversation'
import creator from './creator'
import creatorReports from './creator-reports'
import creatorTab from './creator-tab'
import employee from './employee'
import fansReports from './fans-reports'
import functionPermission from './function-permission'
import global from './global'
import group from './group'
import menu from './menu'
import message from './message'
import messageDraft from './message-draft'
import notification from './notification'
import post from './post'
import role from './role'
import salesSettings from './sales-settings'
import sendPost from './send-post'
import shift from './shift'
import source from './source'
import user from './user'
import { appListener } from './utils'

export const store = configureStore({
  reducer: {
    ...global,
    ...creator,
    ...employee,
    ...fansReports,
    ...group,
    ...menu,
    ...role,
    ...functionPermission,
    ...post,
    ...sendPost,
    ...messageDraft,
    ...shift,
    ...chatterReports,
    ...creatorReports,
    ...conversation,
    ...message,
    ...notification,
    ...user,
    ...source,
    ...creatorTab,
    ...salesSettings,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(appListener.middleware),
})

export type AppStore = typeof store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
